import { h } from 'preact';
import { Text } from 'preact-i18n';
import { withConfig } from '../../config';


function replaceFields(str, fields) {
	return Object.keys(fields).reduce((acc, field) => acc.replace(`{{${field}}}`, fields[field]), str);
}

export function Copyright({ children, copyright }) {
	let fields = { year: new Date().getFullYear() };
	if (copyright) {
		return replaceFields(copyright, fields);
	}
	return <Text id="copyright" fields={fields}>{children}</Text>;

}

const conf = withConfig([
	'headerWidget.copyright'
]);

export default conf(Copyright);
